export default __webpack_public_path__ + "static/suhack-text2-7e5d45d213c94adcd25bf55a73318c90.svg";